<template>

   <div v-if="hide_menu" class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden rounded-r-xl cursor-pointer h-[40px]" @click="toggleMenu">
    <!-- <div class="pl-2">
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    <div class="bg-gray-500 w-8 mt-1.5 h-1 rounded-lg"></div>
    </div> -->
     <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>
  <div
    class="lg:flex fixed w-[95%] bg-white lg:w-[35%] lg:left-0 xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10  rounded-3xl heightfix overflow-y-auto" :class="{'hidden': !isMobile}"
    style="box-shadow: 0px 2px 30px 0px #01b0f926"
  >
   <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
    >
      <!-- <span class="text-2xl">⬅️</span> -->
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>
    <div class="flex flex-col gap-5 relative w-full overflow-y-auto  p-10">
      <!-- old desboard -->
      <!-- <router-link
        :to="{ name: 'AdminDashboards' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminDashboards' }"
      >
        <img
          src="@/assets/newd/icons/Grid.png"
          v-if="$route.name == 'AdminDashboards'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Grid-1.png"
          v-if="$route.name != 'AdminDashboards'"
          alt=""
        />
        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'AdminDashboards',
            'text-[#333333]': $route.name != 'AdminDashboards',
          }"
        >
          Dashboards
        </p>
      </router-link> -->

      <!-- new dasboard -->
      <router-link
        :to="{ name: 'AdminDashboards' }"
        class="flex items-center gap-5 p-4 rounded-3xl "
        :class="{ 'bg-[#0085DB]': isDashboardActive ,'hover:bg-gray-100': $route.name != 'AdminDashboards'}"
      >
        <img
          src="@/assets/newd/icons/Grid.png"
          v-if="isDashboardActive"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Grid-1.png"
          v-if="!isDashboardActive"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': isDashboardActive,
            'text-[#333333]': !isDashboardActive,
          }"
        >
          Dashboards
        </p>
      </router-link>
      <!-- <router-link
        :to="{ name: 'AdminStudents' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminStudents' }"
      >
        <img
          src="@/assets/newd/icons/Archive-1.png"
          v-if="$route.name == 'AdminStudents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Archive.png"
          v-if="$route.name != 'AdminStudents'"
          alt=""
        />
        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'AdminStudents',
            'text-[#333333]': $route.name != 'AdminStudents',
          }"
        >
          Students
        </p>
      </router-link> -->

      <router-link
        :to="{ name: 'AdminCourses' }"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminCourses'  ,'hover:bg-gray-100': $route.name != 'AdminCourses' }"
      >
        <img
          src="@/assets/newd/icons/mdi-light_forum-1.png"
          v-if="$route.name == 'AdminCourses'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/mdi-light_forum.png"
          v-if="$route.name != 'AdminCourses'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white ': $route.name == 'AdminCourses',
            'text-[#333333]': $route.name != 'AdminCourses',
          }"
        >
        Courses
        </p>
      </router-link>

      <router-link
        :to="{ name: 'AdminProject' }"
        class="flex items-center gap-5 p-4 rounded-3xl "
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminProject'  ,'hover:bg-gray-100': $route.name != 'AdminProject' }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'AdminProject'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'AdminProject'"
          alt=""
        />
        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'AdminProject',
            'text-[#333333]': $route.name != 'AdminProject',
          }"
        >
       Blogs
        </p>
      </router-link>

      <router-link
        :to="{ name: 'AdminEvents' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminEvents' ,'hover:bg-gray-100': $route.name != 'AdminEvents' }"
      >
        <img
          src="@/assets/newd/icons/Calendar2Week-1.png"
          v-if="$route.name == 'AdminEvents'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Calendar2Week.png"
          v-if="$route.name != 'AdminEvents'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'AdminEvents',
            'text-[#333333]': $route.name != 'AdminEvents',
          }"
        >
          Events
        </p>
      </router-link>

      <router-link
        :to="{ name: 'AdminAdmins' }"
        class="flex items-center gap-5 p-4 rounded-3xl hidden"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminAdmins'  ,'hover:bg-gray-100': $route.name != 'AdminAdmins' }"
      >
        <img
          src="@/assets/newd/icons/Archive-1.png"
          v-if="$route.name == 'AdminAdmins'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/Archive.png"
          v-if="$route.name != 'AdminAdmins'"
          alt=""
        />

        <p
          class="font-bold text-xs"
          :class="{
            'text-white': $route.name == 'AdminAdmins',
            'text-[#333333]': $route.name != 'AdminAdmins',
          }"
        >
          Credentials 
        </p>
      </router-link>
      <!-- <router-link
        :to="{ name: 'AdminInviteCourse' }"
        class="flex items-center gap-5 p-4 rounded-3xl"
        :class="{ 'bg-[#0085DB]': $route.name == 'AdminInviteCourse' }"
      >
        <img
          src="@/assets/newd/icons/gg_notes-1.png"
          v-if="$route.name == 'AdminInviteCourse'"
          alt=""
        />
        <img
          src="@/assets/newd/icons/gg_notes.png"
          v-if="$route.name != 'AdminInviteCourse'"
          alt=""
        />

        <p
          class="font-bold text-sm"
          :class="{
            'text-white': $route.name == 'AdminInviteCourse',
            'text-[#333333]': $route.name != 'AdminInviteCourse',
          }"
        >
          Invite
        </p>
      </router-link> -->
      
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDashboardActive(){
      return this.$route.name == 'AdminDashboards' ||  this.$route.name == 'AdminStudentDetail' || this.$route.name == 'AdminStaffDetails' || this.$route.name == 'AdminDepartmentDetails' || this.$route.name == 'AdminSemesterDetails' || this.$route.name == 'AdminBatchDetails' || this.$route.name == 'AdminProgramsDetails'
    }
  },
  data(){
    return {
      isMobile: false,
        hide_menu: true,
    }
  },
   methods:{
     toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },
     toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile; // Hide button when menu is open
    },
  }
};
</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}
.heightfix {
  height: calc(100vh - 170px) !important;
}</style>
